import './select.css';

// Native HTML select component with consistent styling
const Select = ({ className = '', children, ...props }) => {
  const backgroundImage = `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`;

  return (
    <select
      className={`select ${className}`.trim()}
      style={{
        backgroundImage,
        backgroundPosition: 'right 0.5rem center',
        backgroundSize: '1.5em 1.5em'
      }}
      {...props}
    >
      {children}
    </select>
  );
};

export { Select };